/**
 * Client-side personrole dedupe — mirrors dashboard/utils/dedupePersonRoles.js
 */

export function dedupePersonRoleDisplay(relations, organisations = {}, roles = {}) {
  if (!Array.isArray(relations) || !relations.length) return [];

  const mapped = relations.map((relation) => ({
    organisation: organisations[relation.org_id] || null,
    role: roles[relation.role_id] || null,
    orgId: relation.org_id ? String(relation.org_id) : '',
    roleId: relation.role_id ? String(relation.role_id) : '',
  }));

  const seen = new Set();
  const out = [];

  for (const r of mapped) {
    const organisation = r.organisation || '';
    const role = r.role || '';
    if (!organisation && !role) continue;
    const key = `${organisation}|${role}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ organisation, role });
  }

  return out;
}

export function dedupeOrgNamesForPerson(relations, organisations = {}) {
  if (!Array.isArray(relations) || !relations.length) return [];

  const names = relations
    .map((r) => organisations[r.org_id])
    .filter(Boolean);

  return [...new Set(names)];
}
